export default __webpack_public_path__ + "static/media/015-ice skate.ab34d709.svg";